import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Downshift from "downshift";
import deburr from "lodash/deburr";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import LabelForm from "../labelForm";
import { useStyles } from "./styles";

function renderInput(inputProps) {
  const { InputProps, classes, ref, ...other } = inputProps;

  return (
    <TextField
      variant="outlined"
      InputProps={{
        inputRef: ref,
        classes: {
          root: classes.inputRoot,
          input: classes.inputInput,
        },
        ...InputProps,
      }}
      {...other}
    />
  );
}

renderInput.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  InputProps: PropTypes.object,
};

function renderSuggestion(suggestionProps) {
  const {
    suggestion,
    index,
    itemProps,
    highlightedIndex,
    selectedItem,
  } = suggestionProps;
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem || "").indexOf(suggestion.label) > -1;

  return (
    <MenuItem
      {...itemProps}
      key={suggestion.label}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
    >
      {suggestion.label}
    </MenuItem>
  );
}

renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.number,
  ]).isRequired,
  index: PropTypes.number.isRequired,
  itemProps: PropTypes.object.isRequired,
  selectedItem: PropTypes.string.isRequired,
  suggestion: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
};

function getSuggestions(value, { showEmpty = false } = {}, suggestions = []) {
  const inputValue = deburr(value.trim()).toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength === 0 && !showEmpty
    ? []
    : suggestions.filter((suggestion) => {
        const keep =
          count < 5 &&
          suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;

        if (keep) {
          count += 1;
        }

        return keep;
      });
}

class DownshiftMultiple extends React.Component {
  constructor(ctx, props) {
    super(props);
    this.state = {
      inputValue: "",
      selectedItem: [],
      selectedValue: [],
    };
  }
  componentDidMount() {
    let { defaultValueState = [] } = this.props;
    if (defaultValueState && defaultValueState.length) {
      defaultValueState = defaultValueState.filter((e) => e);
      this.setState({
        selectedItem: defaultValueState.map((e) => e.label),
        selectedValue: defaultValueState.map((e) => e.value),
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValueState !== this.props.defaultValueState) {
      let { defaultValueState = [] } = nextProps;
      if (defaultValueState && defaultValueState.length) {
        defaultValueState = defaultValueState.filter((e) => e);
        this.setState({
          selectedItem: defaultValueState.map((e) => e.label),
          selectedValue: defaultValueState.map((e) => e.value),
        });
      }
    }
  }
  handleKeyDown = (event) => {
    const { selectedItem, inputValue } = this.state;
    if (
      selectedItem.length &&
      !inputValue.length &&
      event.key === "Backspace"
    ) {
      this.setState({
        selectedItem: selectedItem.slice(0, selectedItem.length - 1),
      });
    }
  };

  handleInputChange = (event) => {
    this.setState({ inputValue: event.target.value });
  };

  handleChange = (item) => {
    const { selectedItem, selectedValue } = this.state;
    const { suggestions } = this.props;
    let newSelectedItem = [...selectedItem];
    if (newSelectedItem.indexOf(item) === -1) {
      newSelectedItem = [...newSelectedItem, item];
    }

    let newSelectedValue = [...selectedValue];
    let find = suggestions.find((suggest) => suggest.label === item);

    if (
      find &&
      find.value &&
      !newSelectedValue.find((e) => e.menuItemId === find.value.menuItemId)
    ) {
      newSelectedValue = newSelectedValue.concat([find.value]);
    }
    this.setState({
      inputValue: "",
      selectedItem: newSelectedItem,
      selectedValue: newSelectedValue,
    });
    this.props.handleGetValue(newSelectedValue);
  };

  handleDelete = (item) => () => {
    const { selectedItem, selectedValue } = this.state;

    const newSelectedItem = [...selectedItem];
    let index = newSelectedItem.indexOf(item);
    newSelectedItem.splice(index, 1);

    let newSelectedValue = [...selectedValue];
    newSelectedValue.splice(index, 1);
    this.setState({
      selectedItem: newSelectedItem,
      selectedValue: newSelectedValue,
    });

    this.props.handleGetValue(newSelectedValue);
  };

  render() {
    const {
      classes,
      placeholder = "",
      suggestions = [],
      label = "",
      InputLabelProps,
      InputProps,
    } = this.props;
    const { inputValue, selectedItem } = this.state;

    return (
      <>
        <LabelForm label={label} />
        <Downshift
          id="downshift-multiple"
          inputValue={inputValue}
          onChange={this.handleChange}
          selectedItem={selectedItem}
        >
          {({
            getInputProps,
            getItemProps,
            getLabelProps,
            isOpen,
            inputValue: inputValue2,
            selectedItem: selectedItem2,
            highlightedIndex,
          }) => {
            const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
              onKeyDown: this.handleKeyDown,
              placeholder: placeholder || "Select multiple",
            });
            return (
              <div className={classes.container}>
                {renderInput({
                  fullWidth: true,
                  classes,
                  // label: label || '',
                  InputLabelProps: {
                    ...getLabelProps(),
                    ...InputLabelProps,
                  },
                  InputProps: {
                    startAdornment: selectedItem.map((item, index) => (
                      <Chip
                        key={item}
                        tabIndex={-1}
                        label={item}
                        className={classes.chip}
                        onDelete={this.handleDelete(item)}
                      />
                    )),
                    onBlur,
                    onChange: (event) => {
                      this.handleInputChange(event);
                      onChange(event);
                    },
                    onFocus,
                    InputProps,
                  },
                  inputProps,
                })}

                {isOpen ? (
                  <Paper className={classes.paper} square>
                    {getSuggestions(inputValue2, {}, suggestions).map(
                      (suggestion, index) =>
                        renderSuggestion({
                          suggestion,
                          index,
                          itemProps: getItemProps({ item: suggestion.label }),
                          highlightedIndex,
                          selectedItem: selectedItem2,
                        })
                    )}
                  </Paper>
                ) : null}
              </div>
            );
          }}
        </Downshift>
      </>
    );
  }
}

DownshiftMultiple.propTypes = {
  classes: PropTypes.object.isRequired,
};

class IntegrationDownshift extends React.Component {
  constructor(ctx, props) {
    super(props);
    this.state = {
      defaultValueState: [],
    };
  }
  componentDidMount() {
    const { defaultValue = [], suggestions = [] } = this.props;
    let data = defaultValue.map((e) => {
      let find = suggestions.find(
        (i) => i.value && i.value.menuItemId === e.menuItemId
      );
      if (find) find.value = e;
      return find;
    });
    this.setState({ defaultValueState: data });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.defaultValue !== nextProps.defaultValue ||
      this.props.suggestions !== nextProps.suggestions
    ) {
      const { defaultValue = [], suggestions = [] } = nextProps;
      let data = defaultValue.map((e) => {
        let find = suggestions.find(
          (i) => i.value && i.value.menuItemId === e.menuItemId
        );
        if (find) find.value = e;
        return find;
      });
      this.setState({ defaultValueState: data });
    }
  }
  render() {
    const { classes, theme, t, ...props } = this.props;
    const { defaultValueState } = this.state;
    return (
      <div className={classes.root}>
        <DownshiftMultiple
          classes={classes}
          {...props}
          defaultValueState={defaultValueState}
        />
      </div>
    );
  }
}

IntegrationDownshift.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default translate("translations")(
  withStyles(useStyles, { withTheme: true })(IntegrationDownshift)
);
